module.exports = __webpack_public_path__ + "media/recipes/92-4d92c57f.png";